import { AppFunctionComponent } from "../../../types"
import { Location } from "@reach/router"
import React, { useState } from "react"
import { connect } from "react-redux"
import { RootState } from "../../../store/index"
import { User } from "../../../auth/dto/user.object"
import { Forum, Path } from "../../constants/routes"
import HeaderBase from "../../components/header/header.component"
import { SubmenuItem } from "../../types/menu.interface"

interface Props {
  siteTitle: string
  pathname: string
  user: User | null
  navigationItems: SubmenuItem[]
}

const ssoPathResolver = (path: string, user: User | null): string => {
  switch (path) {
    case Forum.Home:
      return user ? Forum.SSO : Forum.Home
    default:
      return path
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.data.user,
  }
}

const Header: AppFunctionComponent<Omit<Props, "pathname">> = (props) => {
  const navigationItemsWithProperPath = props.navigationItems.map((item) => {
    return { ...item, path: ssoPathResolver(item.path, props.user) }
  })

  const [mobileMenuOpened, openMobileMenu] = useState(false)

  const openMenu = () => openMobileMenu(!mobileMenuOpened)

  const [_, setTapCount] = useState<[string, number]>(["", 0])

  const onLogoTap = () => {
    setTapCount(["/", 0])
  }
  return (
    <Location>
      {({ location }) => (
        <HeaderBase
          {...props}
          navItems={navigationItemsWithProperPath}
          mobileMenuOpened={mobileMenuOpened}
          onLogoTap={onLogoTap}
          openMenu={openMenu}
          pathname={location.pathname}
          path={Path.Home}
        />
      )}
    </Location>
  )
}

export default connect(mapStateToProps)(Header)
